import { buildProps } from '@jdesign-vue/utils'
import type { ZIndexProperty } from 'csstype'

export interface TabsStickyConfig {
  offset?: number
  target?: string
  zIndex?: ZIndexProperty
  position?: 'top' | 'bottom'
  backgroundColor?: string
}

export const stickyProps = buildProps({
  sticky: {
    type: [Boolean, Object],
    default: false,
  },
} as const)

export const normalizeStickyConfig = (
  sticky: boolean | TabsStickyConfig | undefined
): TabsStickyConfig | false => {
  if (!sticky) return false
  if (sticky === true) return { offset: 0, position: 'top', backgroundColor: '#ffffff' }
  return {
    offset: sticky.offset ?? 0,
    target: sticky.target,
    zIndex: sticky.zIndex ?? 100,
    position: sticky.position ?? 'top',
    backgroundColor: sticky.backgroundColor,
  }
}